import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import HomePage from './pages/HomePage';
import NotFound from './pages/NotFound';
import Footer from './components/Footer';
import Petroleum from './pages/Petroleum';
import Hotels from './pages/Hotels';
import RealEstate from './pages/RealEstate';
import ContactUs from './pages/ContactUs';

function App() {
  return (
  
    <Router>
      <Header></Header>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/petroleum-portfolio" element={<Petroleum />} />
        <Route path="/hospitality-services" element={<Hotels />} />
        <Route path="/real-estate-development" element={<RealEstate />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="*" element={<NotFound />} /> {/* Optional 404 page */}
      </Routes>
      <Footer ></Footer>
    </Router>
  );
}

export default App;